import type {
  BoardViewResponse,
  ProjectDetail,
  Ticket,
  TicketPriority,
  TicketState,
} from '@localagent/sdk';

export const BOARD_COLUMNS: TicketState[] = [
  'backlog',
  'todo',
  'in_progress',
  'in_review',
  'done',
  'cancelled',
];

export const TICKET_STATE_LABELS: Record<TicketState, string> = {
  backlog: 'Backlog',
  todo: 'Todo',
  in_progress: 'In Progress',
  in_review: 'In Review',
  done: 'Done',
  cancelled: 'Cancelled',
};

export const PRIORITY_LABELS: Record<TicketPriority, string> = {
  urgent: 'Urgent',
  high: 'High',
  medium: 'Medium',
  low: 'Low',
  none: 'None',
};

export const PRIORITY_COLORS: Record<TicketPriority, string> = {
  urgent: 'bg-red-500 text-white',
  high: 'bg-orange-500 text-white',
  medium: 'bg-yellow-500 text-black',
  low: 'bg-blue-500 text-white',
  none: 'bg-gray-300 text-gray-700',
};

export const TICKET_STATUS_LABELS: Record<string, string> = {
  specifying: 'Specifying',
  ready: 'Ready',
  needs_input: 'Needs Input',
  planning: 'Planning',
  executing: 'Executing',
  validating: 'Validating',
  changes_requested: 'Changes Requested',
  wont_fix: "Won't Fix",
  duplicate: 'Duplicate',
};

export const STATE_COLORS: Record<TicketState, string> = {
  backlog: 'bg-gray-200 text-gray-700',
  todo: 'bg-blue-100 text-blue-800',
  in_progress: 'bg-yellow-100 text-yellow-800',
  in_review: 'bg-purple-100 text-purple-800',
  done: 'bg-green-100 text-green-800',
  cancelled: 'bg-red-100 text-red-800',
};

export function projectDetailToBoard(detail: ProjectDetail): BoardViewResponse {
  const columns = BOARD_COLUMNS.map((state) => ({ state, tickets: [] as Ticket[] }));
  const byState = new Map(columns.map((column) => [column.state, column.tickets]));
  for (const ticket of detail.tickets) {
    const tickets = byState.get(ticket.state);
    if (!tickets) {
      throw new Error(`ticket ${ticket.identifier} has unknown state ${ticket.state}`);
    }
    tickets.push(ticket);
  }
  // Zero by construction: a project board holds only that project's tickets
  // (work_management ADR-024).
  return { team_id: detail.project.team_id, columns, orphan_ticket_count: 0 };
}
